module.exports = {
    ADD: 'ADD',
    UPDATE: 'UPDATE',
    REMOVE: 'REMOVE',
    RESTORE: 'RESTORE',
    COMMIT: 'COMMIT',
};
